export default "__VITE_ASSET__3e28d87d__"